<div class="buttons">
  <div class="previous-btn">
    <button class="common-btn grey" type="button" [routerLink]="[previousBtnUrl]">{{ 'Subscription 2.Previous' | translate:lang }}</button>
  </div>
  <div class="continue-btn">
    <button class="common-btn blue" type="button" [class.disabled]="continueDisabled" [disabled]="continueDisabled" (click)="onNext()">{{ 'Subscription 2.Continue' | translate:lang }}</button>
  </div>
</div>
